'use client';

export { default } from './Table';
export { default as tableClasses } from './tableClasses';
export * from './tableClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Table/index.js
// module id = 890
// module chunks = 22